import React from "react";
import PropTypes from "prop-types";
import styles from "../../screens/Audience/PushModal/push-modal.module.scss";

function LabelForRow({ title, label }) {
  return (
    <div className={styles.label_row}>
      <h5>{title}</h5>
      <span>{label}</span>
    </div>
  );
}

LabelForRow.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default LabelForRow;
